const SPECIAL_COLORS = ["#1652F0", "#27AE60", "#9B51E0", "#F2994A"];

interface Props {
  choices: string[];
}

export const MultipleChoices = ({ choices }: Props) => {
  return (
    <div className="grid gap-1">
      {choices.map((choice, index) => {
        const color = SPECIAL_COLORS[index % SPECIAL_COLORS.length];
        return (
          <div
            key={choice}
            className="text-sm grid grid-cols-[auto_1fr_auto] gap-2 items-center text-left rounded-sm p-2"
            style={{ backgroundColor: `${color}1A` }}
          >
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="5" cy="5" r="5" fill={color} />
            </svg>
            {choice}
          </div>
        );
      })}
    </div>
  );
};
